<template>
  <confirmacao-sweet-alert
    :value="value"
    titulo="Tem certeza?"
    :mensagem="mensagem"
    texto-confirmar="Sim, excluir!"
    texto-cancelar="Cancelar"
    icone="warning"
    @input="$emit('input', $event)"
    @confirmar="$emit('confirmar')"
    @cancelar="$emit('cancelar')"
    @hidden="$emit('hidden')"
  />
</template>

<script lang="js">
import ConfirmacaoSweetAlert from "../ConfirmacaoSweetAlert.vue";

/**
 * Modal de confirmação de exclusão de um envolvido (terceiro).
 *
 * Encapsula a configuração visual no padrão de confirmação do design system
 * (título "Tem certeza?", ícone de alerta, confirmar azul e cancelar vermelho),
 * reutilizando `ConfirmacaoSweetAlert`. A lógica de exclusão permanece fora da grid
 * (`ListaTerceiros`), na etapa `EnvolvimentoTerceiros`/containers.
 *
 * @prop {boolean} value - controla a exibição (v-model)
 * @prop {string} [mensagem] - texto do corpo do modal
 *
 * @emits input {boolean} visibilidade do modal
 * @emits confirmar - usuário confirmou a exclusão
 * @emits cancelar - usuário cancelou/voltou
 * @emits hidden - modal finalizou o fechamento
 */
export default {
  name: "ModalExcluirTerceiro",

  components: {
    ConfirmacaoSweetAlert
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    mensagem: {
      type: String,
      default:
        "Você realmente deseja excluir este envolvido? Essa ação não pode ser desfeita."
    }
  }
};
</script>


